const guidedFlowFeatures = {
    customFlowSystemId: undefined,
    isDeviceActivationGuideIntentAutoOpenEnabled: false,
    isGuidedFlowRecommendationEnabled: false,
};

const workspaceCustomerFeatures = {
    isAutoSummaryEnabled: false,
    isPreviousSessionSummaryEnabled: false,
};

const workspaceSalesFeatures = {
    isRapportEnabled: false,
    isChecklistSummaryEnabled: false,
    isChallengeEnabled: false,
    isGaiaCallResolutionEnabled: false,
    isDynamicSmartOfferEnabled: false,
    isUsingMovedDiscoveryAndEngagementQuestions: false,
};

const workspaceExpertFeatures = {
    includesSendToPartnerMeta: false,
    isProactiveEnabled: false,
    isVerizonCareEnabled: false,
    isLightModeEnabled: false,
    isGaiaMultiStepSummaryEnabled: false,
    isChatIssueSummaryEnabled: false,
    isMicroLearningV2Enabled: false,
    isMorningPaperEnabled: false,
    logoutPendingDuration: 3000,
    isTrainingFeedbackEnabled: false,
    isUpdatedEndSessionFlowEnabled: false,
    sendSummaryFromBackend: false,
    isPacingEnabled: false,
    useMdnForAccountNo: false,
    isUpdatedCustomerHandoffEnabled: false,
};

/**
 * Maps clean feature flag names (used in code) to actual flag names (used in API)
 * This allows us to use clean names like `IsChecklistSummaryEnabled` in code
 * while fetching the actual flag name like `Sales-IsChecklistSummaryEnabled`
 */
export const FLAG_NAME_MAP: Record<string, string> = {
    isChallengeEnabled: "Sales-isChallengeEnabled",
    isMicroLearningV2Enabled: "EWP-isMicroLearningV2Enabled",
    logoutPendingDuration: "EWP-logoutPendingDuration",
    isChecklistSummaryEnabled: "Sales-IsChecklistSummaryEnabled",
    isRapportEnabled: "Sales-isRapportEnabled",
    isUsingMovedDiscoveryAndEngagementQuestions: "Sales-isUsingMovedDiscoveryAndEngagementQuestions",
};

export const workspaceFeatures = {
    ...guidedFlowFeatures,
    ...workspaceCustomerFeatures,
    ...workspaceExpertFeatures,
    ...workspaceSalesFeatures,
};
